module.exports = __webpack_public_path__ + "static/media/27n.a841cf04.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/27n.svg
// module id = 171
// module chunks = 0